module.exports = __webpack_public_path__ + "static/media/icon_share_link.cea2cf30.svg";